import { render, staticRenderFns } from "./PageGames.vue?vue&type=template&id=117684e2&scoped=true&"
import script from "./PageGames.vue?vue&type=script&lang=js&"
export * from "./PageGames.vue?vue&type=script&lang=js&"
import style0 from "./PageGames.vue?vue&type=style&index=0&id=117684e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117684e2",
  null
  
)

export default component.exports